const DRAFT_PREFIX = "grand-system:draft:";
const clearedDraftKeys = new Set<string>();

export function buildFormDraftKey(form: string, id: string | number | null | undefined = "new"): string {
  return `${DRAFT_PREFIX}${form}:${id ?? "new"}`;
}

export function loadFormDraft<T>(key: string): T | null {
  clearedDraftKeys.delete(key);
  if (typeof window === "undefined") return null;
  try {
    const raw = window.localStorage.getItem(key);
    if (!raw) return null;
    return JSON.parse(raw) as T;
  } catch {
    return null;
  }
}

export function saveFormDraft<T>(key: string, value: T): void {
  if (clearedDraftKeys.has(key)) return;
  if (typeof window === "undefined") return;
  try {
    window.localStorage.setItem(key, JSON.stringify(value));
  } catch {
    /* localStorage pode estar indisponivel ou cheio. */
  }
}

export function clearFormDraft(key: string, options: { suppressAutosave?: boolean } = {}): void {
  if (options.suppressAutosave !== false) {
    clearedDraftKeys.add(key);
  }
  if (typeof window === "undefined") return;
  try {
    window.localStorage.removeItem(key);
  } catch {
    /* ignore */
  }
}
